export default __webpack_public_path__ + "static/media/ai_assistant_square.8bf37efc.png";